import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './home.module.css';

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideCount = 4;
  const interval = 4000;

  // ✅ SET BODY STYLE khi vào Home page
  useEffect(() => {
    // Lưu style cũ
    const originalBg = document.body.style.backgroundColor;
    const originalColor = document.body.style.color;
    const originalFont = document.body.style.fontFamily;
    const originalOverflow = document.body.style.overflowX;
    
    // Set style cho Home
    document.body.style.backgroundColor = '#000';
    document.body.style.color = '#f5f5f7';
    document.body.style.fontFamily = "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif";
    document.body.style.overflowX = 'hidden';
    
    // Cleanup: khôi phục khi unmount
    return () => {
      document.body.style.backgroundColor = originalBg;
      document.body.style.color = originalColor;
      document.body.style.fontFamily = originalFont;
      document.body.style.overflowX = originalOverflow;
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slideCount);
    }, interval);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(
      `.${styles.heroSection}, .${styles.gridItem}`
    );
    elements.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const moveSlider = (index) => setCurrentIndex(index);

  return (
    <main className={styles.content}>
      {/* ===== iPhone 15 Pro ===== */}
      <section className={`${styles.heroSection} ${styles.heroIphone15pro}`}>
        <picture>
          <source
            media="(max-width:734px)"
            srcSet={process.env.PUBLIC_URL + '/images/hinh1-mobile.jpeg'}
          />
          <img
            src={process.env.PUBLIC_URL + '/images/hinh1.jpg'}
            alt="iPhone 15 Pro"
            loading="lazy"
          />
        </picture>
        <div className={styles.heroContent}>
          <h2>iPhone 15 Pro</h2>
          <p>Titan. Thật bền chắc. Thật nhẹ. Thật Pro</p>
          <div className={styles.heroButtons}>
            <button className={`${styles.btn} ${styles.btnSecondary}`}>
              Tìm hiểu thêm
            </button>
            <Link
              to="/shop"
              className={`${styles.btn} ${styles.btnPrimary}`}
            >
              Mua
            </Link>
          </div>
        </div>
      </section>

      {/* ===== iPhone 15 ===== */}
      <section className={`${styles.heroSection} ${styles.heroIphone15}`}>
        <picture>
          <source
            media="(max-width:734px)"
            srcSet={process.env.PUBLIC_URL + '/images/hinh2-mobile.jpeg'}
          />
          <img
            src={process.env.PUBLIC_URL + '/images/hinh2.jpeg'}
            alt="iPhone 15"
            loading="lazy"
          />
        </picture>
        <div className={styles.heroContent}>
          <h2>iPhone 15</h2>
          <p>Camera mới. Thiết kế mới. Mới lịm tim.</p>
          <div className={styles.heroButtons}>
            <button className={`${styles.btn} ${styles.btnSecondary}`}>
              Tìm hiểu thêm
            </button>
            <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
          </div>
        </div>
      </section>

      {/* ===== iPad Pro ===== */}
      <section className={`${styles.heroSection} ${styles.heroIpadpro}`}>
        <picture>
          <source
            media="(max-width:734px)"
            srcSet={process.env.PUBLIC_URL + '/images/hinh6-mobile.jpeg'}
          />
          <img
            src={process.env.PUBLIC_URL + '/images/hinh6.jpg'}
            alt="iPad Pro"
            loading="lazy"
          />
        </picture>
        <div className={styles.heroContent}>
          <h2>iPad Pro</h2>
          <p>Mỏng không tưởng. Mạnh không ngờ</p>
          <div className={styles.heroButtons}>
            <button className={`${styles.btn} ${styles.btnSecondary}`}>
              Tìm hiểu thêm
            </button>
            <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
          </div>
        </div>
      </section>

      {/* ===== GRID SECTIONS ===== */}
      <Container fluid>
        {/* Row 1: AirPods & MacBook Air */}
        <Row className={styles.gridSection}>
          <Col md={6} className={`${styles.gridItem} ${styles.gridAirpods}`}>
            <img
              src={process.env.PUBLIC_URL + '/images/hinh3.jpg'}
              alt="AirPods"
              loading="lazy"
            />
            <div className={styles.gridContent}>
              <h2>AirPods</h2>
              <p>Âm Thanh Thích Ứng. Đang phát</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>

          <Col md={6} className={`${styles.gridItem} ${styles.gridMacbookAir}`}>
            <img
              src={process.env.PUBLIC_URL + '/images/hinh3-ph.jpg'}
              alt="MacBook Air"
              loading="lazy"
            />
            <div className={styles.gridContent}>
              <h2>MacBook Air</h2>
              <p>Cỗ máy M3. Gọn bằng. Cân mọi việc</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Row 2: Apple Watch Series 9 & Ultra 2 */}
        <Row className={styles.gridSection}>
          <Col md={6} className={`${styles.gridItem} ${styles.gridWatchSeries}`}>
            <img
              src={process.env.PUBLIC_URL + '/images/tr-hinh4.jpg'}
              alt="Apple Watch Series 9"
              loading="lazy"
            />
            <div className={styles.gridContent}>
              <h2>APPLE WATCH</h2>
              <h3>SERIES 9</h3>
              <p>Thông minh hơn. Sáng hơn. Quyền năng hơn</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>

          <Col md={6} className={`${styles.gridItem} ${styles.gridWatchUltra}`}>
            <img
              src={process.env.PUBLIC_URL + '/images/ph-hinh4.jpg'}
              alt="Apple Watch Ultra 2"
              loading="lazy"
            />
            <div className={styles.gridContent}>
              <h2>APPLE WATCH</h2>
              <h3>ULTRA 2</h3>
              <p>Một đẳng cấp phiêu lưu mới</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Row 3: iPad Air & MacBook Pro */}
        <Row className={styles.gridSection}>
          <Col md={6} className={`${styles.gridItem} ${styles.gridIpadAir}`}>
            <img
              src={process.env.PUBLIC_URL + '/images/tr-hinh5.jpg'}
              alt="iPad Air"
              loading="lazy"
            />
            <div className={styles.gridContent}>
              <h2>
                iPad <span style={{ fontFamily: "'Brush Script MT', cursive", color: '#bf5af2' }}>air</span>
              </h2>
              <p>Hai kích cỡ. Chip nhanh hơn. Đa zi năng</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>

          <Col md={6} className={`${styles.gridItem} ${styles.gridMacbookPro}`}>
            <picture>
              <source
                media="(max-width:734px)"
                srcSet={process.env.PUBLIC_URL + '/images/ph-hinh5-mobile.jpeg'}
              />
              <img
                src={process.env.PUBLIC_URL + '/images/ph-hinh5.jpeg'}
                alt="MacBook Pro"
                loading="lazy"
              />
            </picture>

            <div className={styles.gridContent}>
              <h2>MacBook Pro</h2>
              <p>Chấn động. Ấn tượng</p>
              <div className={styles.gridButtons}>
                <button className={`${styles.btn} ${styles.btnPrimary}`}>Mua</button>
                <button className={`${styles.btn} ${styles.btnSecondary}`}>
                  Tìm hiểu thêm
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ===== SLIDER ===== */}
      <section className={styles.sliderContainer}>
        <div className={styles.slider}>
          <div
            className={styles.list}
            style={{
              transform: `translateX(-${100 * currentIndex}%)`,
              transition: 'transform 0.6s ease-out',
            }}
          >
            {[1, 2, 3, 4].map((num, i) => (
              <div className={styles.item} key={i}>
                <picture>
                  <source
                    media="(max-width:1000px)"
                    srcSet={process.env.PUBLIC_URL + `/images/sile${num}-mobe.jpeg`}
                  />
                  <img
                    src={process.env.PUBLIC_URL + `/images/slide-${num}.jpg`}
                    alt={`Slide ${num}`}
                    loading="lazy"
                  />
                </picture>
                <div className={styles.slideContent}>
                  <p>
                    {[
                      'Phiêu lưu. Có những bí mật không thể bị chôn vùi.',
                      'Tâm lý. Từ Steven Spielberg, Tom Hanks và Gary Goetzman.',
                      'Hình sự. Series mới.',
                      'Giải trí mới. Hứa hẹn gây sốc.',
                    ][i]}
                  </p>
                  <button className={styles.btn}>Xem Ngay</button>
                </div>
              </div>
            ))}
          </div>

          {/* Dots */}
          <ul className={styles.dots}>
            {[0, 1, 2, 3].map((i) => (
              <li
                key={i}
                className={i === currentIndex ? styles.active : ''}
                onClick={() => moveSlider(i)}
              ></li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}

export default Home;